<template>
    <div v-if="banner">
    <section class="region region-seo">

        <a
            v-if="banner.url"
            class="region-seo-link" :href="banner.url" :title="banner.name">
            <img class="region-seo-img hidden-on-mobile" :src="banner.image" :alt="banner.name" :title="banner.name">
            <img class="region-seo-img hidden-on-desktop" :src="banner.smallImage" :alt="banner.name" :title="banner.name">
        </a>
        <img v-if="! banner.url" class="region-seo-img hidden-on-mobile" :src="banner.image" :alt="banner.name" :title="banner.name">
        <img v-if="! banner.url" class="region-seo-img hidden-on-desktop" :src="banner.smallImage" :alt="banner.name" :title="banner.name">

    </section>
    </div>
</template>

<script>
export default {
    name: 'Banner',

    props: {
        banner: {
            type: Object,
            required: false,
        },
    }
}
</script>

<style scoped>

</style>
